import React from 'react';
import { useTranslation } from 'react-i18next';

import heroVuzLogo from '@shared/assets/lg_ag26/hero_vuz_logo.svg';
import unlockVuzWordmark from '@shared/assets/lg_ag26/unlock_vuz_wordmark.svg';
import unlockVuzWordmarkAr from '@shared/assets/lg_ag26/unlock_vuz_wordmark_ar.svg';
import giftIcon from '@shared/assets/lg_ag26/gift.png';

import styles from '../styles/UnlockVuzBanner.module.css';

interface Props {
  showTrial?: boolean;
}


export const UnlockVuzBanner: React.FC<Props> = ({ showTrial = true }) => {
  const { t, i18n } = useTranslation();
  const isArabic = String(i18n.language || '').toLowerCase().startsWith('ar');
  const wordmark = isArabic ? unlockVuzWordmarkAr : unlockVuzWordmark;

  return (
    <div className={styles.container}>
      <div className={styles.logoGroup}>
        <div className={styles.logoSafespace}>
          <img className={styles.heroLogo} src={heroVuzLogo} alt="VUZ" />
        </div>

        <div className={styles.unlockBadge}>
          <span className={styles.unlockBadgeInner}>
            <span className={styles.unlockText}>{t('lg_ag26_unlock')}</span>
            <img
              className={isArabic ? styles.unlockWordmarkAr : styles.unlockWordmark}
              src={wordmark}
              alt="VUZ"
            />
          </span>
        </div>
      </div>

      {showTrial ? (
        <div className={styles.giftRow}>
          <img className={styles.giftIcon} src={giftIcon} alt="" aria-hidden />
          <div className={styles.trialInfo}>
            <div className={styles.freeBadge}>
              <span className={styles.freeBadgeText}>{t('lg_ag26_free_badge')}</span>
            </div>
            <p className={styles.priceLine}>{t('lg_ag26_price_line')}</p>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default UnlockVuzBanner;
